import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal, Panel } from 'react-bootstrap';
import moment from 'moment';

import SubmissionCommentDetail from '../../components/project_submission/SubmissionCommentDetail';
import {
  createComment,
  listComment,
} from '../../redux/project_inspection/submission_comment_actions';

import { defaultRejectHandler } from '../../utils/utility';

class SubmissionCommentModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
      isCreated: false,
    };

    this.commentDetailRef = null;
  }

  onAddCommentHandler() {
    const comment = this.commentDetailRef.getWrappedInstance().getCommentData();
    this.props.createComment(comment.name, comment.description);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.show && this.props.show !== prevProps.show) {
      const { submission } = this.props;
      if (submission && !this.props.isLoading) {
        this.props.listComment();
      }
    }

    if (!this.props.isCreating && this.props.isCreating !== prevProps.isCreating && !this.props.errorMessage) {
      this.setState({ isSubmittable: false, isDirty: false, isCreated: true });
      this.commentDetailRef.getWrappedInstance().clearInputData();
    }

    if(!this.state.isDirty && this.state.isDirty !== prevState.isDirty){
      this.setState({ isCreated: false });
    }
  }

  renderComments(comments) {
    const { t } = this.props;
    return (
      comments.map(({ id, name, user: creator, created_date, description }) => (
        <Panel key={`comment-${id}`}>
          <Panel.Heading>
            <Panel.Title componentClass="h3" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>{name}</div>
              <div>
                <span>
                  {`${t('by')} ${creator} ${t('on')} ${moment(created_date).format('DD-MM-YYYY hh:mm')}`}
                </span>
              </div>
            </Panel.Title>
          </Panel.Heading>
          <Panel.Body>{description}</Panel.Body>
        </Panel>
      ))
    );
  }

  render() {
    const {
      comments,
      isLoading,
      isCreating,
      isDeleting,
      errorMessage,
      submissionDetail,
      t,
      ...newProps
    } = this.props;
    const { isSubmittable, isDirty } = this.state;
    const isInProgress = isCreating || isLoading || isDeleting;
    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('comment submission')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SubmissionCommentDetail
            submission={submissionDetail}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            ref={ref => (this.commentDetailRef = ref)}
            t={t}
            onSubmit={() => this.state.isSubmittable && !this.props.isCreating && !this.state.isCreated && this.onAddCommentHandler()}
          />
          <div style={{ maxHeight: '600px', overflow: 'auto' }}>
            {this.renderComments(comments)}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="submission-comment-add"
            style={{ width: 140 }}
            bsStyle="success"
            disabled={isInProgress || !isSubmittable || !isDirty}
            onClick={() => this.onAddCommentHandler()}
          >
            {isCreating ? `${t('adding')}...` : t('add')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.submissionComment.isLoading,
  comments: state.submissionComment.orderedIds.map(id => state.submissionComment.objects[id]),
  isCreating: state.submissionComment.isCreating,
  errorMessage: state.submissionComment.errorMessage,
});

const mapDispatchToProps = (dispatch, { submission }) => ({
  createComment: (name, description) => defaultRejectHandler(dispatch(createComment(submission.id, name, description))),
  listComment: () => defaultRejectHandler(dispatch(listComment(submission.id))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(SubmissionCommentModal),
);



// WEBPACK FOOTER //
// ./src/modal/project_submission/SubmissionCommentModal.js